import { RootState } from "store/store";

export const selectCategories = (state: RootState) => {
  return state.categories.list;
};

export const selectPublicTags = (state: RootState) => {
  return state.categories.list
    .filter((item) => Boolean(item.isPublic) === true)
    .map((item) => item.tags)
    .flat(1);
};
